import React, { FC } from 'react';
import { TwilioMessage } from 'models/twilio';
import useTwilioMessage from 'components/twilio/hooks/useTwilioMessage';
import generateMessageId from 'components/twilio/utils/generateMessageId';

export interface SystemMessageHandlerProps {
  messages: TwilioMessage[];
}

const SystemMessageHandler: FC<SystemMessageHandlerProps> = ({ messages }) => {
  const { getMessageComponent } = useTwilioMessage(false);

  return (
    <>
      {messages.map((message) => (
        <React.Fragment key={generateMessageId(message.index)}>
          {getMessageComponent(message)}
        </React.Fragment>
      ))}
    </>
  );
};

export default SystemMessageHandler;
